// Shared by the skip-navigation link in BaseLayout and JoinLayout.
//
// The link keeps a real href="#main-content" so the browser performs the focus
// jump to <VMain id="main-content" tabindex="-1"> natively — that native jump is
// what makes the link work for assistive tech, so it must not be preventDefault'd.
// The side effect we don't want is "#main-content" being left in the address bar:
// it persists into shared/bookmarked URLs and re-fires the jump on reload.
//
// nextTick defers the cleanup until after the browser has acted on the hash;
// stripping it synchronously would cancel the jump we just asked for.
export const useSkipNav = () => {
  const cleanHash = () => {
    nextTick(() => {
      history.replaceState(null, '', window.location.pathname + window.location.search)
    })
  }

  return { cleanHash }
}
